import React, { useEffect, useState } from "react";
import { View, Text, TextInput, FlatList, TouchableOpacity, StyleSheet } from "react-native";
import Feather from '@expo/vector-icons/Feather';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ajax from "../../../../../helpers/ajaxHelper";
import Urls from "../../../../../services/Urls";
import { useIsFocused } from "@react-navigation/native";
import moment from 'moment';
import { navigate } from "../../../../../navigation/RootNavigation";
import { showSuccesToast } from "../../helpers";
import TenantModal from "../modals/teanantModal";
import { tenantActions } from "../../../redux/tenant.actions";
import { useDispatch, useSelector } from "react-redux";
import getPlatformType from "../../../../../helpers/helpers";
const PropertiesTable = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showLocationDialog, setShowLocationDialog] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("england_wales");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [properties, setProperties] = useState([]);
  const focused = useIsFocused();
  const LoginState = useSelector((state) => state?.Login?.userDetails);
  const layout=getPlatformType();

  useEffect(() => {
    ajax
      .get(Urls.Properties)
      .then(({ data }) => {
        if (data.status) {
          setProperties(data?.payload);
        } else {

        }
      })
      .catch((error) => {
        console.log('error', error);
      });
      setSelectedItem(null)
  }, [focused]);

  const startFlow = (country) => {
    ajax
      .get(Urls.Search_FLOW + "/" + selectedItem)
      .then(({ data }) => {
        console.log('Data', data)
        if(data.status){
          if(data?.data && data?.data?.length == 0){
            createFlow(country)
          }else{
            setOpen({show:true, data:data?.data})
          }
        }else{
          createFlow(country)
        }
        
     
      })
      .catch((error) => {
        console.log('error', error);
      });

  }
  const dispatch = useDispatch()
  const createFlow =(country = selectedCountry)=>{
    ajax
    .post(Urls.START_FLOW, { property_id: selectedItem, country })
    .then(({ data }) => {
      console.log('Data', data)
      if (data.status) {
        showSuccesToast("New flow Created successfully!")
        if (data?.data?.openflow_id) {
          dispatch(tenantActions.addNRemovedLandlord({ landlords: 
            [{
              opbrix_id: "",
              title: "",
              first_name: LoginState?.first_name,
              last_name: LoginState?.last_name,
              email: LoginState?.email,
              number: LoginState?.contact_number,
              post_code: LoginState?.postcode,
              address: LoginState?.address,
              tenant_id: LoginState?.id,
              is_lead: true
            }]

           }, data?.data?.openflow_id));
        }
          navigate('TeanantOnboarding', { id: data?.data?.openflow_id });
          
      } else {

      }
    })
    .catch((error) => {
      console.log('error', error);
    });
  }
  const filteredProperties = properties?.filter((item) =>
    item?.name?.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  console.log("selectedItem", selectedItem)
  const toggleSelection = (id) => {
    setSelectedItem(id);
  };

  const handleLocationSubmit = () => {
    setShowLocationDialog(false);
    startFlow(selectedCountry);
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Properties</Text>
      <Text style={styles.subtitle}>Please search and select the property the tenant(s) will move into.</Text>

      <View style={{ flexDirection:layout=="phone"?'column' :'row',gap:12,marginBottom: 20, justifyContent: 'space-between' }}> <TextInput
        style={styles.searchInput}
        placeholder="Search"
        value={searchQuery}
        onChangeText={setSearchQuery}
      />
        <TouchableOpacity
          style={[styles.button, { opacity: selectedItem ? 1 : 0.5 }]}
          onPress={() => setShowLocationDialog(true)}
          disabled={!selectedItem}
        >
          <Text style={styles.buttonText}>+ START NEW FLO</Text>
        </TouchableOpacity>
      </View>

      {filteredProperties && filteredProperties.length ?
        <FlatList
          data={filteredProperties}
          keyExtractor={(item) => item?.hubita_id}
          renderItem={({ item }) => {
            console.log("item", item)
            return (
              <TouchableOpacity
                style={[styles.row, selectedItem == item.id && styles.selectedRow]}
                onPress={() => toggleSelection(item.id)}
              >
                <View style={[styles.checkbox, selectedItem === item.id && styles.selectedCheckbox]}>
                  {selectedItem == item.id && <Feather name="check" size={14} color="black" />}
                </View>
                <Text numberOfLines={3} style={styles.cell}>{item.name}</Text>
                <Text numberOfLines={3} style={styles.cell}>{item.postcode}</Text>
                <Text numberOfLines={3} style={styles.cell}>{
                  moment(item.updatedAt).format('YYYY-MM-DD')
                }</Text>
              </TouchableOpacity>
            )
          }}
        /> : null}
      <TenantModal isVisible={open?.show} data={open?.data}  
      onClose={()=>{
        setOpen(null);
        setSelectedItem(null)
      }}
      onProceed={()=>{
        setOpen(null)
        createFlow()
      }}
      onSelectTenant={(data)=>{
        setOpen(null)
        navigate('TeanantOnboarding', { id: data?.openflow_id });
      }}
      />

      <Dialog
        open={showLocationDialog}
        maxWidth="sm"
        fullWidth
        onClose={() => setShowLocationDialog(false)}
      >
        <DialogContent>
          <Typography variant="h6" color="primary" style={{ marginBottom: 24 }}>
            Where is the property located?
          </Typography>

          <FormControl component="fieldset">
            <RadioGroup
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
            >
              <FormControlLabel
                value="england_wales"
                control={<Radio color="primary" />}
                label="England and Wales"
              />
              <FormControlLabel
                value="scotland"
                control={<Radio color="primary" />}
                label="Scotland"
              />
              <FormControlLabel
                value="northern_ireland"
                control={<Radio color="primary" />}
                label="Northern Ireland"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions style={{ padding: "0 24px 20px" }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setShowLocationDialog(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLocationSubmit}
          >
            Start Flo
          </Button>
        </DialogActions>
      </Dialog>
    </View>
  );
};
const layout =getPlatformType()
const styles = StyleSheet.create({
  container: { padding: 10, backgroundColor: "#fff", borderRadius: 10, elevation: 5, shadowColor: "#000", shadowOpacity: 0.1, shadowRadius: 4, shadowOffset: { width: 0, height: 2 }, marginTop: 20 },
  title: { fontSize: 20, fontWeight: "bold", color: "#7D57C1", marginBottom: 10 },
  subtitle: { fontSize: 14, color: "gray", marginBottom: 10 },
  searchInput: { borderWidth: 1, padding: 8, borderRadius: 5, borderColor: "#ccc", flex: 1 },
  button: { backgroundColor: "#7D57C1", padding: 10, borderRadius: 5, alignItems: "center" },
  buttonText: { color: "white", fontWeight: "bold" },
  row: { flexDirection: "row", alignItems: "center", padding: 10, borderBottomWidth: 1, borderColor: "#ddd", borderRadius: 5, backgroundColor: "#fff" },
  selectedRow: { backgroundColor: "#EEE4FF" },
  checkbox: { width: 20, height: 20, borderWidth: 1, alignItems: "center", justifyContent: "center", marginRight: 10, borderColor: "#7D57C1", borderRadius: 4 },
  selectedCheckbox: { backgroundColor: "#7D57C1" },
  cell: { flex: 1, paddingLeft: 10,maxWidth:'30%',fontSize:layout=="web"?16 : 10 },
  paginationContainer: { flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginTop: 10 },
  paginationText: { fontSize: 14, color: "gray" },
  paginationDropdown: { fontSize: 14, fontWeight: "bold", color: "#7D57C1", marginHorizontal: 5 },
  pageButton: { padding: 10, fontSize: 16, color: "#7D57C1" },
  disabledButton: { color: "gray" },
});

export default PropertiesTable;
